export const API_CARRIER_COUNTERPARTY_NEW = '/carrierCounterpartyNew';

export const API_CONTACT = '/contact';
export const API_CHANGE_CARRIER_STATUS = '/changeCarrierStatus';
export const API_COUNTERPARTY_CHECK = '/counterparty/check';

export const WS_TOPICS_ADDRESS_ORG = '/topic/carrier';
export const WS_TOPICS_ADDRESS_ORG_ID = (orgId: string): string => `/topic/carrier/${orgId}`;
